<template >
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="card card-body card-panel-box border-0 p-5" style="    margin: 1vw .9vw;">
     <div class="d-flex justify-content-between align-items-center mb-2">
       <div class="d-flex">
         <small class="fw-bolder"><span>تدوین ارکان جهت ساز</span> / <span>  ارکان جهت ساز پیشنهادی    </span></small>

       </div>
       <button class="btn btn-primary btn-submit-1" @click="$router.go(-1)">برگشت</button>
     </div>
        <hr class="mb-3">
        <div class="d-flex flex-nowrap flex-column">
          <div v-if="counter===0" class="card col-12 shadow border-radius-20 d-flex flex-column align-items-start p-2">
            <div class="alert alert-info">
              <p class="text-justify">
                مبنای وجودی شرح مي دهد كه چرا فعاليتهاي سازمان و آنچه را كه انجام مي دهد مهم هستند و سبب خلق ارزش پايدار براي ذينفعان مي شوند. مبناي وجودي سازمان در حقيقت مفهوم ژرف و عميقي از علت وجودي سازمان بوده و ملاك تعريف اكوسيستم و فعاليت با ساير اجزاي اكوسيستم محسوب مي شوند.
              </p>
            </div>
            <hr>
            <p class="fw-bold">
              مبنای وجودی
            </p>
            <hr>
            <textarea v-model="philosophy" name="" class="form-control" id="" cols="30" rows="10"></textarea>
          </div>
          <div v-if="counter===1" class="mt-4 shadow border-radius-20 col-12 d-flex flex-column align-items-start p-2">
            <div class="alert alert-info">
              <p class="text-justify">
                مأموريت‌ يك‌ سازمان‌، خط‌ يا خطوط‌ كسب‌ و كار آن‌ را تشريح‌ مي‌كند. محصولات‌ و خدمات‌ آن‌ راتعيين‌ مي‌نمايد، و بازارهايي‌ را كه ‌در حال‌ و آينده‌ در آنها فعاليت‌ مي‌كند،را مشخص ‌مي‌سازد.
               </p>
              <p class="text-justify">
                مأموريت‌، باورهاي‌ كلي‌ و هدفمدار مديران‌ يك‌ سازمان‌ دربارة‌ هدف‌، قابليتها و جايگاه‌ سازمان‌ است‌ كه‌ موجوديت‌ سازمان‌ را توجيه‌ مي‌كند.
               </p>
              <p class="text-justify">
                مأموريت‌، بيان‌ رسمي‌ هدف‌ اساسي‌اي‌ است‌ كه‌ در پشت‌ موجوديت‌ يك‌ سازمان‌ قرار دارد يا به‌عبارت‌ ديگر دليل‌ وجودي‌ سازمان‌ است‌.
               </p>
            </div>
            <hr>
            <p class="fw-bold">
             ماموریت
            </p>            <hr>
            <textarea v-model="mission" name="" class="form-control" id="" cols="30" rows="10"></textarea>
          </div>
          <div v-if="counter===2" class="mt-4 shadow  border-radius-20 col-12 d-flex flex-column align-items-start p-2">
            <div class="alert alert-info">
              <p class="text-justify">
                چشم‌انداز هر سازمان نشاندهنده تصويري است كه از آينده آن سازمان در ذهن مديران و كاركنان وجود دارد. چشم‌انداز سازمان يك بيان كلي از اهداف درازمدت و راهبردي سازمان است كه همه منابع و برنامه‌هاي جاري آن را در جهت دستيابي به اين اهداف همسو و همراستا مي‌سازد.
               </p>
              <ul class="mx-4">
                <li class="text-end">	واقع گرايانه و امكان پذير باشد.</li>
                <li class="text-end">	واضح و قابل فهم باشد.</li>
                <li class="text-end">	پسنديده و مطلوب باشد.</li>
                <li class="text-end">	بلند پروازانه باشد.</li>
                <li class="text-end">	تغيير شرايط آينده را حتي‌الامكان پاسخگويي كند.</li>
                <li class="text-end">	برانگيزاننده و بسيج كننده باشد.</li>
                <li class="text-end">	هدايت كننده و جهت دهنده باشد.</li>
              </ul>
            </div>
            <p class="fw-bold">
              چشم انداز پیشنهادی
            </p>
            <textarea v-model="vision" name="" class="form-control" id="" cols="30" rows="10"></textarea>
          </div>
        </div>
        <hr class="mb-2 mt-2">
        <div class="d-flex align-items-center justify-content-between">
          <p  @click.prevent="back" class="btn btn-submit-1 btn-primary" style="width: 8vw !important;">  مرحله قبل</p>
          <p  @click.prevent="next" class="btn btn-submit-1 btn-primary" style="width: 8vw !important;">ذخیره و مرحله بعدی</p>
        </div>







      </div>
    </div>
  </div>


</template>

<script>
// @ is an alias to /src
import Sidebar from "@/components/Sidebar/Sidebar";
import splash from "@/components/Splash/Splash";
import router from "@/router";
import {useToast} from "vue-toastification";
const toast = useToast();

// to="/Vision_working_group_future"
export default {
  name: 'HomeView',
  components: {
    Sidebar,
    splash
  },
  data(){
    return{
      Error: false,
      counter: 0,
      philosophy: '',
      mission: '',
      vision: '',
    }
  },
  methods:{
    checkIsMother(){
      if (this.is_mother){
        router.push('/mother_items')
        return
      }

    },
    update(){

    },
    next(){
      if (this.counter===0){
        if (!this.philosophy) {
        toast.error('فلسفه اجباری است!')
        return
      }

        fetch(`${this.base_url}/VisionQuestion/update`, {
          method: 'POST',
          headers: {
            "Authorization": `Bearer ${this.$cookies.get('token')}`,
            'Content-type': 'application/json; charset=UTF-8',
          },
          body: JSON.stringify({
            'philosophy': this.philosophy,
          }),
        })
            .then(response => response.json())
            .then((response) => {
              if (response['error']) {
                toast.success(response.error)
                return
              }
              if (response.message){
                toast.success(response.message)

              }


            }).catch((err) => {
        })
      }
      if (this.counter===1){
        if (!this.mission) {
          toast.error('ماموریت اجباری است!')
          return
        }
        fetch(`${this.base_url}/VisionQuestion/update`, {
          method: 'POST',
          headers: {
            "Authorization": `Bearer ${this.$cookies.get('token')}`,
            'Content-type': 'application/json; charset=UTF-8',
          },
          body: JSON.stringify({
            'mission': this.mission,
          }),
        })
            .then(response => response.json())
            .then((response) => {
              if (response['error']) {
                toast.success(response.error)
                return
              }
              if (response.message){
                toast.success(response.message)

              }


            }).catch((err) => {
        })
      }
      if (this.counter===2){

        if (!this.vision) {
          toast.error('چشم انداز اجباری است!')
          return
        }
        fetch(`${this.base_url}/VisionQuestion/update`, {
          method: 'POST',
          headers: {
            "Authorization": `Bearer ${this.$cookies.get('token')}`,
            'Content-type': 'application/json; charset=UTF-8',
          },
          body: JSON.stringify({
            'vision': this.vision,
          }),
        })
            .then(response => response.json())
            .then((response) => {

              if (response.message){
                toast.success(response.message)

              }


            }).catch((err) => {
        })
      }
      this.counter ++

      if (this.counter===3){
        router.push('/Vision_working_group_Gary_Hamel_questionnaire/ByType')
      }

    },
    back(){
      this.counter -=1

      if (this.counter===-1){
        router.push('/Vision_working_group_future')
      }
    },
    all() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var url = new URL(`${this.base_url}/VisionQuestion`);


      var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(url, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.data) {
              this.vision = response.data.vision
              this.mission = response.data.mission
              this.philosophy = response.data.philosophy
            }
          })
          .catch(error => console.error('Error:', error));

    },
  },
  mounted() {
    this.checkIsMother()
    this.all()
  }
}
</script>
<style scoped lang="scss">
a{
  font-size: 1vw;
}

/*.line_after{
  position: relative;
  &::after{
    position: absolute;
    width: 0.01vw;
    height: 53vw;
    content: '';
    background-color: #efecf3 !important;
    top: 5vw;
    right: 35.3vw ;
    border-radius: 1vw;
  }
}*/

h3{
  font-size: 1.3vw !important;
}
small{
  font-size: 1vw !important;
}
textarea{
  height: 6vw !important;
}
</style>